import { useState, useEffect, useCallback } from "react";
import {
  getDashboardStats,
  getRevenueAnalytics,
  getRecentUsers,
  getLeaveRequests,
  DashboardStats,
  RevenueAnalytics,
  RecentUsersResponse,
  LeaveRequestsResponse,
} from "@/services/admin";

interface UseDashboardDataReturn {
  stats: DashboardStats | null;
  revenueData: RevenueAnalytics | null;
  users: RecentUsersResponse | null;
  leaveRequests: LeaveRequestsResponse | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useDashboardData(): UseDashboardDataReturn {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [revenueData, setRevenueData] = useState<RevenueAnalytics | null>(null);
  const [users, setUsers] = useState<RecentUsersResponse | null>(null);
  const [leaveRequests, setLeaveRequests] = useState<LeaveRequestsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // const [statsData, revenueAnalyticsData, usersData, leaveRequestsData] = await Promise.all([
      //   getDashboardStats(),
      //   getRevenueAnalytics(),
      //   getRecentUsers(5),
      //   getLeaveRequests("pending"),
      // ]); 

      // setStats(statsData);
      // setRevenueData(revenueAnalyticsData);
      // setUsers(usersData);
      // setLeaveRequests(leaveRequestsData);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch dashboard data");
      console.error("Dashboard data fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
    // Set up auto-refresh every 30 seconds
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [fetchData]);

  return {
    stats,
    revenueData,
    users,
    leaveRequests,
    loading,
    error,
    refetch: fetchData,
  };
}
